import { createEffect, JSX } from 'solid-js';
import { useKeyboardShortcuts } from '../../utils/useKeyboardShortcuts';

export interface TerminalButtonProps {
	action: () => void; // Made optional for TransferPanel form submit
	keyBinding: string;
	text: string;
	disabled?: boolean;
	grow?: boolean;
	children?: JSX.Element;
	'data-testid'?: string;
}

export const TerminalButton = (props: TerminalButtonProps) => {
	createEffect(() => {
		// Only register keyboard shortcut if not disabled
		if (!props.disabled) {
			useKeyboardShortcuts([{ action: props.action, key: props.keyBinding }]);
		}
	});

	return (
		<button
			onClick={() => !props.disabled && props.action()}
			disabled={props.disabled}
			data-testid={props['data-testid']}
			class="flex items-center border px-4 py-2 uppercase transition-colors duration-200 focus:outline-none"
			classList={{
				'w-full': props.grow,
				// Enabled state
				'border-green bg-gray text-green hover:border-orange hover:text-orange focus:border-yellow focus:ring-1 focus:ring-yellow':
					!props.disabled,
				// Disabled state
				'border-gray bg-black text-gray cursor-not-allowed': props.disabled,
			}}
		>
			[{props.keyBinding}] {props.text}
			{props.children}
		</button>
	);
};
